"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.en = void 0;
exports.en = {
    nextPage: 'Next page',
    prevPage: 'Previous page',
    pageNumber: 'Page number',
    pageNumberShort: 'Page #',
    perPage: {
        many: '{count} per page',
        some: '{count} per page',
        one: '{count} per page',
    },
    of: 'of',
    page: 'Page {number}',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvUGFnaW5hdGlvbi9QYWdpbmF0aW9uLmkxOG4vZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxFQUFFLEdBQUc7SUFDZCxRQUFRLEVBQUUsV0FBVztJQUNyQixRQUFRLEVBQUUsZUFBZTtJQUN6QixVQUFVLEVBQUUsYUFBYTtJQUN6QixlQUFlLEVBQUUsUUFBUTtJQUN6QixPQUFPLEVBQUU7UUFDTCxJQUFJLEVBQUUsa0JBQWtCO1FBQ3hCLElBQUksRUFBRSxrQkFBa0I7UUFDeEIsR0FBRyxFQUFFLGtCQUFrQjtLQUMxQjtJQUNELEVBQUUsRUFBRSxJQUFJO0lBQ1IsSUFBSSxFQUFFLGVBQWU7Q0FDeEIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBlbiA9IHtcbiAgICBuZXh0UGFnZTogJ05leHQgcGFnZScsXG4gICAgcHJldlBhZ2U6ICdQcmV2aW91cyBwYWdlJyxcbiAgICBwYWdlTnVtYmVyOiAnUGFnZSBudW1iZXInLFxuICAgIHBhZ2VOdW1iZXJTaG9ydDogJ1BhZ2UgIycsXG4gICAgcGVyUGFnZToge1xuICAgICAgICBtYW55OiAne2NvdW50fSBwZXIgcGFnZScsXG4gICAgICAgIHNvbWU6ICd7Y291bnR9IHBlciBwYWdlJyxcbiAgICAgICAgb25lOiAne2NvdW50fSBwZXIgcGFnZScsXG4gICAgfSxcbiAgICBvZjogJ29mJyxcbiAgICBwYWdlOiAnUGFnZSB7bnVtYmVyfScsXG59O1xuIl19